<template lang="pug">
  .clients
    .page-header
      h2 Clients
      .content-search
        select(v-model="searchFilter")
          option(value="all") All Records
          option(value="name") Name
          option(value="alias") Alias
          // option(value="ip") IP Address
          option(value="cid") Player ID
        input(type="text", placeholder="Search Clients...", v-model="searchTerm", @keyup.enter="search").filtered.buttoned
        .search-go(@click="search")
          magnify-icon

    h3 Clients

    table(cellspacing="0", cellpadding="0")
      tr
        th ID&nbsp;
          span.mobile-hide(@click="updateFilter('clients.id', 'ASC')").filter.asc #[menu-up-icon]
          span.mobile-hide(@click="updateFilter('clients.id', 'DESC')").filter.desc #[menu-down-icon]
        th Name&nbsp;
          span.mobile-hide(@click="updateFilter('clients.name', 'ASC')").filter.asc #[menu-up-icon]
          span.mobile-hide(@click="updateFilter('clients.name', 'DESC')").filter.desc #[menu-down-icon]
        th Level&nbsp;
          span.mobile-hide(@click="updateFilter('groups.level', 'ASC')").filter.asc #[menu-up-icon]
          span.mobile-hide(@click="updateFilter('groups.level', 'DESC')").filter.desc #[menu-down-icon]
        th Connections&nbsp;
          span.mobile-hide(@click="updateFilter('clients.connections', 'ASC')").filter.asc #[menu-up-icon]
          span.mobile-hide(@click="updateFilter('clients.connections', 'DESC')").filter.desc #[menu-down-icon]
        th.mobile-hide First Seen&nbsp;
          span(@click="updateFilter('clients.time_add', 'ASC')").filter.asc #[menu-up-icon]
          span(@click="updateFilter('clients.time_add', 'DESC')").filter.desc #[menu-down-icon]
        th.mobile-hide Last Seen&nbsp;
          span(@click="updateFilter('clients.time_edit', 'ASC')").filter.asc #[menu-up-icon]
          span(@click="updateFilter('clients.time_edit', 'DESC')").filter.desc #[menu-down-icon]

      tr(v-for="client of clients", @click="redirect(client.id)")
        td @{{ client.id }}
        td {{ client.name }}
        td {{ client.level }}
        td {{ client.connections }}
        td.mobile-hide {{ client.time_add | unixDate }}
        td.mobile-hide {{ client.time_edit | unixDate }}

    pagination(:page="$route.params.page", :pages="pages", uri="/clients/")
</template>

<script>
import ClientsService from '@/services/Clients';
import Pagination from '@/components/core/Pagination.vue';

import MenuUpIcon from 'vue-material-design-icons/MenuUp.vue';
import MenuDownIcon from 'vue-material-design-icons/MenuDown.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';

export default {
  name: 'clients',
  components: {
    Pagination,
    MenuUpIcon,
    MenuDownIcon,
    MagnifyIcon,
  },
  data() {
    return {
      clients: [],
      pages: 1,
      filter: 'clients.id',
      order: 'ASC',
      searchFilter: 'all',
      searchTerm: '',
    };
  },
  methods: {
    async update() {
      if (!this.$route.params.page) {
        this.$route.params.page = 1;
      }

      const response = await ClientsService.getClients(this.$route.params.page, this.filter, this.order, this.searchFilter, this.searchTerm);
      if (response.error) {
        console.log(response.error);
      } else {
        this.clients = response.data.clients;
        this.pages = response.data.pages;
      }
    },
    updateFilter(filter, order) {
      // Only update if the filter has actually changed (prevent spamming the backend for no reason)
      if (this.filter !== filter || this.order !== order) {
        this.filter = filter;
        this.order = order;
        this.update();
      }
    },
    redirect(id) {
      this.$router.push({ name: 'client', params: { id } });
    },
    search() {
      this.$router.push({ name: 'clients', params: { page: 1 } });
      this.update();
    },
  },
  created() {
    this.update();
  },
  watch: {
    $route() {
      this.update();
    },
  },
};
</script>

<style lang="scss" scoped>
.clients {
  table tr td {
    cursor: pointer;
  }
}
</style>
